import React from 'react';
// import * as Helmet from 'react-helmet-async';

const Head = ({ title, description, image, type, children }) => {
  return (
    // <Helmet>
    <React.Fragment>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content={
          image
            ? image
            : 'https://spectrum.chat/img/apple-icon-144x144-precomposed.png'
        }
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type || 'website'} />
      <meta
        property="og:image"
        content={
          image
            ? image
            : 'https://spectrum.chat/img/apple-icon-144x144-precomposed.png'
        }
      />
      {children}
    </React.Fragment>
    // </Helmet>
  );
};

export default Head;